<template>
    <section class=" inline large">
        <div class="fixed fixed-max-sm">
            <div class="text-center img">
                <img :src="glb.cdnUrl + 'vimages/increase-home-value.svg'" loading="lazy"/>
            </div>
            <div class="text-center wrap">
                <h2><b class="f3 text-bold">Monitor Your Home's Market Value</b></h2>
                <div>
                    Receive an accurate valuation of your home based on other properties in your neighborhood, and identify the optimum time to sell.
                </div>
            </div>
        </div>
    </section>
</template>

<script src="./valuation-card.js"></script>

